<template>
  <div>
    <p class="title is-6 mt-2 mb-1">{{ title }} Styles</p>
    <div class="style-toolkit">
      <div v-if="show_width">
        <up-numberinput
          v-model="styles.width"
          size="sm"
          label="Width"
          labelIcon="mdi mdi-alpha-w-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="show_height">
        <up-numberinput
          v-model="styles.height"
          size="sm"
          label="Height"
          labelIcon="mdi mdi-alpha-h-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="show_bg_color">
        <up-textinput
          v-model="styles.bg_color"
          size="sm"
          label="Bg Color"
          labelIcon="mdi mdi-format-color-fill"
        ></up-textinput>
      </div>
      <div v-if="show_border_color">
        <up-textinput
          v-model="styles.border_color"
          size="sm"
          label="Border Color"
          labelIcon="mdi mdi-border-none-variant"
        ></up-textinput>
      </div>
      <div v-if="show_border_width">
        <up-numberinput
          v-model="styles.border_width"
          label="Border Width"
          size="sm"
          labelIcon="mdi mdi-border-style"
        ></up-numberinput>
      </div>
      <div v-if="show_font_color">
        <up-textinput
          v-model="styles.font_color"
          size="sm"
          label="Font Color"
          labelIcon="mdi mdi-format-color-text"
        ></up-textinput>
      </div>
      <div v-if="show_font_size">
        <up-numberinput
          v-model="styles.font_size"
          size="sm"
          label="Font Size"
          labelIcon=""
        ></up-numberinput>
      </div>
      <div v-if="show_x">
        <up-numberinput
          v-model="styles.x"
          label="X"
          size="sm"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="show_y">
        <up-numberinput
          v-model="styles.y"
          label="Y"
          size="sm"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="show_margin">
        <up-numberinput
          v-model="styles.margin"
          label="Margin"
          size="sm"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="show_text_align">
        <up-select
          label="Text Alignment"
          labelIcon="mdi mdi-alpha-y-box-outline"
          v-model="styles.text_align"
        >
          <option value="L">Left</option>
          <option value="C">Center</option>
          <option value="R">Right</option>
        </up-select>
      </div>
    </div>
  </div>
</template>
<script>
import { defaultStyleValue } from "./utils";
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSelect from "@/components/UI/Inputs/UpSelect";
export default {
  name: "style-editor",
  components: {
    UpTextinput,
    UpNumberinput,
    UpSelect,
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      },
    },
    title: {
      type: String,
      default: "",
    },
    show_width: {
      type: Boolean,
      default: false,
    },
    show_height: {
      type: Boolean,
      default: false,
    },
    show_bg_color: {
      type: Boolean,
      default: false,
    },
    show_border_color: {
      type: Boolean,
      default: false,
    },
    show_font_color: {
      type: Boolean,
      default: false,
    },
    show_font_size: {
      type: Boolean,
      default: false,
    },
    show_text_align: {
      type: Boolean,
      default: false,
    },
    show_x: {
      type: Boolean,
      default: false,
    },
    show_y: {
      type: Boolean,
      default: false,
    },
    show_margin: {
      type: Boolean,
      default: false,
    },
    show_border_width : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      styles: defaultStyleValue(),
    };
  },
  watch: {
    styles: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.styles = new_val;
      },
      deep: true,
    },
  },
  created() {
    for (let key in this.styles) {
      if (this.value[key] !== null) {
        this.styles[key] = this.value[key];
      }
    }
  },
};
</script>

<style scoped>
.style-toolkit {
  display: flex;
  gap: 10px;
}
</style>
